/* AUTH */
export const ANALYTIC_POST_LISTEN_DURATION = 'ANALYTIC_POST_LISTEN_DURATION';
export const ANALYTIC_POST_LISTEN_DURATION_SUCCESS = 'ANALYTIC_POST_LISTEN_DURATION_SUCCESS';
export const ANALYTIC_POST_LISTEN_DURATION_FAILED = 'ANALYTIC_POST_LISTEN_DURATION_FAILED';